import { lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ErrorBoundary from "../components/ErrorBoundary";

// Lazy load protected page components
const DashboardPage = lazy(() =>
  import("../views/view.exports").then((module) => ({
    default: module.DashboardPage,
  })),
);
const CustomersPage = lazy(() =>
  import("../views/view.exports").then((module) => ({
    default: module.CustomersPage,
  })),
);
const CustomerDetailsPage = lazy(() =>
  import("../views/view.exports").then((module) => ({
    default: module.CustomerDetails,
  })),
);
const StaffPage = lazy(() =>
  import("../views/view.exports").then((module) => ({
    default: module.StaffPage,
  })),
);
const LicensePage = lazy(() =>
  import("../views/view.exports").then((module) => ({
    default: module.LicensePage,
  })),
);

const ProtectedRoutes = () => {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route
          path="/customers/:customerId"
          element={<CustomerDetailsPage />}
        />
        <Route path="/license" element={<LicensePage />} />
        <Route path="/staff" element={<StaffPage />} />
        <Route path="/" element={<Navigate to="/customers" replace />} />
      </Routes>
    </ErrorBoundary>
  );
};

export default ProtectedRoutes;
